import React, { useEffect } from 'react';

export default function Privacy() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="pt-32 pb-20 bg-slate-50 min-h-screen">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white rounded-[2rem] p-8 md:p-12 shadow-sm border border-slate-100">
          <h1 className="text-3xl md:text-4xl font-extrabold text-slate-900 mb-8">Privacy Policy</h1>
          
          <div className="space-y-6 text-slate-600 leading-relaxed">
            <p>Last updated: {new Date().toLocaleDateString()}</p>
            
            <h2 className="text-xl font-bold text-slate-900 mt-8 mb-4">Information We Collect</h2>
            <p>
              We collect information you provide directly to us, including your name, email address, physical address, phone number, medical history, and payment information when you use our services. We also automatically collect certain technical data when you visit our website.
            </p>

            <h2 className="text-xl font-bold text-slate-900 mt-8 mb-4">HIPAA Compliance</h2>
            <p>
              RenewRX is fully committed to protecting your Personal Health Information (PHI). All medical data collected through our platform is encrypted and handled in strict accordance with the Health Insurance Portability and Accountability Act (HIPAA) guidelines.
            </p>

            <h2 className="text-xl font-bold text-slate-900 mt-8 mb-4">How We Use Your Information</h2>
            <p>
              We use the information we collect to:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Facilitate medical consultations with licensed providers.</li>
              <li>Process and fulfill your prescriptions through our partner pharmacies.</li>
              <li>Communicate with you about your account, treatments, and customer service inquiries.</li>
              <li>Improve and optimize our website and services.</li>
            </ul>

            <h2 className="text-xl font-bold text-slate-900 mt-8 mb-4">Information Sharing</h2>
            <p>
              We only share your personal and medical information with the healthcare professionals evaluating your case and the pharmacies fulfilling your prescriptions. We do not sell your personal information to third parties.
            </p>

            <h2 className="text-xl font-bold text-slate-900 mt-8 mb-4">Security</h2>
            <p>
              We implement advanced security measures designed to protect your information from unauthorized access, alteration, disclosure, or destruction. However, no internet transmission is completely secure, and we cannot guarantee absolute security.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}